import { Flex, Select } from "antd";
import { FormattedMessage } from "react-intl";
import { GroupingConferenceDivision } from "~pages/Standings/enums/groupingConferenceDivision";
import { GroupingStagePool } from "~pages/Standings/enums/groupingStagePool";
import type { getStandingGroupings } from "~pages/Standings/StandingsListPage/utilities/getStandingGroupings";

type Props = {
  standingsGrouping: ReturnType<typeof getStandingGroupings>;
  grouping?: GroupingStagePool;
  conferenceGrouping?: GroupingConferenceDivision;
  setGrouping: (value: GroupingStagePool) => void;
  setConferenceGrouping: (value: GroupingConferenceDivision) => void;
  parentSelect?: {
    labelIntlKey: string;
    value?: string;
    options: Array<{ label: string; value: string }>;
    onChange: (value: string) => void;
  };
  disabled: boolean;
};

export const StandingsGroupingControls = ({
  standingsGrouping,
  grouping,
  conferenceGrouping,
  setGrouping,
  setConferenceGrouping,
  parentSelect,
  disabled,
}: Props) => (
  <Flex gap={10} align="center" wrap="wrap">
    {standingsGrouping.STAGE_POOL.values.length > 1 && (
      <Flex gap={10} align="center">
        <FormattedMessage id="standings.table.grouping.stage" />
        <Select
          disabled={disabled}
          value={grouping}
          onSelect={(value) => {
            setGrouping(value);
            setConferenceGrouping(GroupingConferenceDivision.Overall);
          }}
          style={{ width: 130 }}
          options={standingsGrouping.STAGE_POOL.values.map((item) => ({ label: item, value: item }))}
        />
      </Flex>
    )}
    {standingsGrouping.CONFERENCE_DIVISION.values.length > 1 && (
      <Flex gap={10} align="center">
        <FormattedMessage id="standings.table.grouping.conf" />
        <Select
          disabled={disabled}
          value={conferenceGrouping}
          onSelect={(value) => {
            setConferenceGrouping(value);
            setGrouping(GroupingStagePool.Overall);
          }}
          style={{ width: 150 }}
          options={standingsGrouping.CONFERENCE_DIVISION.values.map((item) => ({ label: item, value: item }))}
        />
      </Flex>
    )}
    {parentSelect && parentSelect.options.length > 0 && (
      <Flex gap={10} align="center">
        <span>
          <FormattedMessage id={parentSelect.labelIntlKey} />:
        </span>
        <Select
          disabled={disabled}
          value={parentSelect.value}
          onSelect={parentSelect.onChange}
          style={{ width: 200 }}
          options={parentSelect.options}
        />
      </Flex>
    )}
  </Flex>
);
